export enum StagesStatusEnum {
  draft = 'DRAFT',
  pending_consent = 'PENDING_CONSENT',
  pending_payment = 'PENDING_PAYMENT',
  pending_documents = 'PENDING_DOCUMENTS',
  pending_reply = 'PENDING_REPLY',
  form_endorsement = 'FORM_ENDORSEMENT',
  make_appointment = 'MAKE_APPOINTMENT',
  pending_solicitor = 'PENDING_SOLICITOR',
  pending_financial_review = 'PENDING_FINANCIAL_REVIEW',
  pending_additional_payment = 'PENDING_ADDITIONAL_PAYMENT',
  prepare_completion = 'PREPARE_COMPLETION',
  application_cancelled = 'APPLICATION_CANCELLED',
  application_rejected = 'APPLICATION_REJECTED',
  ipa_granted = 'IPA_GRANTED',
}
